import { jsx } from 'panel';
import { ButtonEl } from '../button';
import { ButtonTheme } from '../button/constants';
export function template() {
  const {
    isCollapsed
  } = this.state;
  return jsx("div", {
    sel: '.wrapper',
    class: {
      collapsed: isCollapsed,
      'is-hovering': this.state.isHovering,
      'is-resizing': this.state.isResizing
    },
    style: {
      '--sidebar-width': "".concat(this.state.width, "px")
    },
    attrs: {
      elref: "wrapper"
    }
  }, this.attr("show-collapse-button") && jsx("div", {
    sel: '.collapse-wrapper'
  }, jsx(ButtonEl, {
    attrs: {
      elref: "collapseButton",
      theme: ButtonTheme.Tertiary,
      icon: isCollapsed ? "push-right" : "push-left"
    },
    on: {
      click: () => this.toggleCollapsed()
    }
  })), jsx("div", {
    sel: '.content-wrapper',
    attrs: {
      elref: "contentWrapper"
    },
    on: {
      mouseenter: () => this.update({
        isHovering: true
      }),
      mouseleave: () => this.update({
        isHovering: false
      })
    }
  }, jsx("slot", null)), this.helpers.isExpandedStyle() && jsx("div", {
    sel: '.resize-handle',
    on: {
      mousedown: this.helpers.startResizing,
      mouseenter: () => this.update({
        isHovering: true
      }),
      mouseleave: () => this.update({
        isHovering: false
      })
    },
    class: {
      'default-width': this.state.width === this.attr("default-width")
    },
    attrs: {
      elref: "resizeHandle"
    }
  }));
}